const imagesList = [
  "./images/monk-gallery_01.png",
  "./images/monk-gallery_02.png",
  "./images/monk-gallery_03.png",
  "./images/monk-gallery_04.png",
  "./images/monk-gallery_05.png",
];

export default imagesList;
